export default __webpack_public_path__ + "static/media/example_robot1.5e85c4d5.png";